// DPoP 키 쌍과 관련 함수들
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var dpopKeyPair = null;
/**
 * DPoP 키 쌍 생성 (브라우저 Web Crypto API 사용)
 */ export function generateDPoPKeyPair() {
    return _generateDPoPKeyPair.apply(this, arguments);
}
function _generateDPoPKeyPair() {
    _generateDPoPKeyPair = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (dpopKeyPair) {
                        return [
                            2,
                            dpopKeyPair
                        ];
                    }
                    return [
                        4,
                        crypto.subtle.generateKey({
                            name: 'ECDSA',
                            namedCurve: 'P-256'
                        }, true, [
                            'sign',
                            'verify'
                        ])
                    ];
                case 1:
                    dpopKeyPair = _state.sent();
                    return [
                        2,
                        dpopKeyPair
                    ];
            }
        });
    });
    return _generateDPoPKeyPair.apply(this, arguments);
}
/**
 * JWK (JSON Web Key) 형식으로 공개키 내보내기
 */ export function exportPublicKeyAsJWK(keyPair) {
    return _exportPublicKeyAsJWK.apply(this, arguments);
}
function _exportPublicKeyAsJWK() {
    _exportPublicKeyAsJWK = _async_to_generator(function(keyPair) {
        var jwk;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.exportKey('jwk', keyPair.publicKey)
                    ];
                case 1:
                    jwk = _state.sent();
                    return [
                        2,
                        jwk
                    ];
            }
        });
    });
    return _exportPublicKeyAsJWK.apply(this, arguments);
}
/**
 * Base64 URL 인코딩
 */ function base64URLEncode(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';
    for(var i = 0; i < bytes.byteLength; i++){
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function sha256(data) {
    return _sha256.apply(this, arguments);
}
function _sha256() {
    _sha256 = /**
 * Simple SHA-256 hash implementation for DPoP
 */ _async_to_generator(function(data) {
        var encoder, dataBuffer;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    encoder = new TextEncoder();
                    dataBuffer = encoder.encode(data);
                    return [
                        4,
                        crypto.subtle.digest('SHA-256', dataBuffer)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _sha256.apply(this, arguments);
}
/**
 * DPoP proof JWT 생성
 */ export function createDPoPProof(htm, htu, accessToken// 선택적: API 호출 시 액세스 토큰 바인딩
) {
    return _createDPoPProof.apply(this, arguments);
}
function _createDPoPProof() {
    _createDPoPProof = _async_to_generator(function(htm, htu, accessToken) {
        var jwk, header, payload, _tmp, _tmp1, _tmp2, encodedHeader, encodedPayload, dataToSign, signature, encodedSignature;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!dpopKeyPair) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        generateDPoPKeyPair()
                    ];
                case 1:
                    dpopKeyPair = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        exportPublicKeyAsJWK(dpopKeyPair)
                    ];
                case 3:
                    jwk = _state.sent();
                    // JWT 헤더
                    header = {
                        typ: 'dpop+jwt',
                        alg: 'ES256',
                        jwk: jwk
                    };
                    _tmp = [
                        {
                            jti: crypto.randomUUID(),
                            htm: htm.toUpperCase(),
                            htu: htu,
                            iat: Math.floor(Date.now() / 1000)
                        }
                    ];
                    _tmp1 = accessToken;
                    if (!_tmp1) return [
                        3,
                        5
                    ];
                    _tmp2 = {};
                    return [
                        4,
                        sha256(accessToken)
                    ];
                case 4:
                    _tmp1 = (_tmp2.ath = base64URLEncode.apply(void 0, [
                        _state.sent()
                    ]), _tmp2);
                    _state.label = 5;
                case 5:
                    payload = _object_spread.apply(void 0, _tmp.concat([
                        _tmp1
                    ]));
                    // Base64 URL 인코딩
                    encodedHeader = base64URLEncode(new TextEncoder().encode(JSON.stringify(header)));
                    encodedPayload = base64URLEncode(new TextEncoder().encode(JSON.stringify(payload)));
                    // 서명할 데이터
                    dataToSign = "".concat(encodedHeader, ".").concat(encodedPayload);
                    return [
                        4,
                        crypto.subtle.sign({
                            name: 'ECDSA',
                            hash: 'SHA-256'
                        }, dpopKeyPair.privateKey, new TextEncoder().encode(dataToSign))
                    ];
                case 6:
                    signature = _state.sent();
                    encodedSignature = base64URLEncode(signature);
                    // 최종 JWT
                    return [
                        2,
                        "".concat(encodedHeader, ".").concat(encodedPayload, ".").concat(encodedSignature)
                    ];
            }
        });
    });
    return _createDPoPProof.apply(this, arguments);
}
/**
 * DPoP 헤더를 포함한 요청 옵션 생성
 */ export function createDPoPHeaders(method, url, accessToken, existingHeaders) {
    return _createDPoPHeaders.apply(this, arguments);
}
function _createDPoPHeaders() {
    _createDPoPHeaders = _async_to_generator(function(method, url, accessToken, existingHeaders) {
        var dpopProof;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        createDPoPProof(method, url, accessToken)
                    ];
                case 1:
                    dpopProof = _state.sent();
                    return [
                        2,
                        _object_spread_props(_object_spread({}, existingHeaders), {
                            'DPoP': dpopProof
                        })
                    ];
            }
        });
    });
    return _createDPoPHeaders.apply(this, arguments);
}
/**
 * DPoP 지원 확인 (선택적)
 * 
 * Spring Authorization Server가 DPoP 토큰 발급을 지원하지 않으므로 
 * DPoP 기능을 비활성화합니다.
 */ export function isDPoPSupported() {
    // DPoP 기능 비활성화 - Spring Authorization Server는 DPoP 토큰 발급 미지원
    return false;
// 기존 Web Crypto API 지원 확인 코드 (주석 처리)
// return !!(
//   window.crypto &&
//   window.crypto.subtle &&
//   typeof window.crypto.subtle.generateKey === 'function' &&
//   typeof window.crypto.subtle.sign === 'function'
// );
}
